export const groupProductsByCarrier = (products = []) => {
  return products.reduce((acc, product) => {
    const carrier = (product?.telco || "OUTROS").toUpperCase();
    if (!acc[carrier]) {
      acc[carrier] = [];
    }
    acc[carrier].push(product);
    return acc;
  }, {});
};

export const getCarrierOptions = (productsByCarrier = {}) =>
  Object.keys(productsByCarrier).sort((a, b) => a.localeCompare(b));

export const getPlanOptions = (products = []) => {
  const names = products
    .map((product) => product?.name)
    .filter(Boolean);
  return [...new Set(names)].sort((a, b) => a.localeCompare(b));
};

export const filterProductsByCarrier = ({
  productsByCarrier = {},
  selectedOperators = [],
  selectedPlans = [],
}) => {
  const carriers =
    selectedOperators.length > 0
      ? selectedOperators
      : Object.keys(productsByCarrier);

  return carriers
    .map((carrier) => {
      const plans = productsByCarrier[carrier] || [];
      const availablePlans =
        selectedPlans.length > 0
          ? plans.filter((plan) => selectedPlans.includes(plan.name))
          : plans;

      const isMulti = availablePlans.some(
        (plan) => Number(plan.many_carriers) > 0
      );

      return {
        carrier,
        availablePlans,
        isMulti,
      };
    })
    .filter(({ availablePlans }) => availablePlans.length > 0);
};
